// API client for audit log viewer (ADM-012)
import { apiClient } from './client'

export interface AuditLogEntry {
  id: number
  user_id: string | null
  org_id: string | null
  action: string
  entity_type: string
  entity_id: string | null
  actor_type: string | null
  actor_source: string | null
  actor_name: string | null
  actor_subject: string | null
  delegated_by_user_id: string | null
  old_value: Record<string, unknown> | null
  new_value: Record<string, unknown> | null
  ip_address: string | null
  user_agent: string | null
  created_at: string
  user_name: string | null
  user_email: string | null
  org_name: string | null
  delegated_by_name: string | null
  delegated_by_email: string | null
}

export interface AuditLogListResponse {
  items: AuditLogEntry[]
  total: number
  page: number
  page_size: number
}

export interface AuditLogParams {
  date_from?: string
  date_to?: string
  user_id?: string
  action?: string
  entity_type?: string
  actor_type?: string
  actor_source?: string
  search?: string
  page?: number
  page_size?: number
}

export interface AuditFilterUser {
  id: string
  full_name: string
  email: string
}

export interface AuditLogFilters {
  actions: string[]
  entity_types: string[]
  actor_types: string[]
  actor_sources: string[]
  users: AuditFilterUser[]
}

export const fetchAuditLog = async (
  params: AuditLogParams
): Promise<AuditLogListResponse> => {
  const response = await apiClient.get<AuditLogListResponse>('/audit-log/', {
    params,
  })
  return response.data
}

export const fetchAuditLogFilters = async (): Promise<AuditLogFilters> => {
  const response = await apiClient.get<AuditLogFilters>('/audit-log/filters')
  return response.data
}

export const exportAuditLogCsv = async (
  params: Omit<AuditLogParams, 'page' | 'page_size' | 'search'>
): Promise<void> => {
  const response = await apiClient.get('/audit-log/export.csv', {
    params,
    responseType: 'blob',
  })

  const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' })
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'audit_log.csv')
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}
